import React, { useState } from "react";
import { Col, Row, SegmentedControl } from "components/bootstrap";
import { IfPermitted, Spinner } from "components/common";
import CollectionMembershipConfigSection from "collections/components/CollectionMembershipConfigSection";
import ProfileSection from "./ProfileSection";
import SharedEntitiesSection from "./SharedEntitiesSection";
import UsersSection from "./UsersSection";
import RolesSection from "./RolesSection";
import CollectionsSection from "./CollectionsSection";
export const editableTeamSegments = [
  { value: "profile", label: "Profile" },
  { value: "users_roles", label: "Users & Roles" },
  { value: "collections", label: "Collections" }
];
const TeamDetails = ({ team }) => {
  const [selectedSegment, useSelectedSegment] = useState("profile");
  const teamSegments = [
    ...editableTeamSegments,
    { value: "shared_entities", label: "Shared Entities" }
  ];
  if (!team) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(SegmentedControl, { data: teamSegments, value: selectedSegment, onChange: useSelectedSegment })), /* @__PURE__ */ React.createElement(Col, { md: 12 }, selectedSegment === "profile" && /* @__PURE__ */ React.createElement(ProfileSection, { team }), selectedSegment === "users_roles" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `team_users:list:${team.id}` }, /* @__PURE__ */ React.createElement(UsersSection, { team })), /* @__PURE__ */ React.createElement(RolesSection, { team })), selectedSegment === "collections" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CollectionMembershipConfigSection, { entityId: team.id, entityType: "team", readOnly: true }), /* @__PURE__ */ React.createElement(CollectionsSection, { team })), selectedSegment === "shared_entities" && /* @__PURE__ */ React.createElement(SharedEntitiesSection, { teamId: team.id })));
};
export default TeamDetails;
